import { TranslationStore } from "./translation/TranslationStore";
import { GlobalApplicationContext } from "../application/GlobalApplicationContext";
import { normalizeI18nKey } from "./util";
export class GlobalTranslationStore {
    constructor() { }
    static $t(key) {
        if (!GlobalTranslationStore.instance) {
            const { rootContainer } = GlobalApplicationContext.default.fastoche;
            const store = rootContainer.get(TranslationStore);
            GlobalTranslationStore.instance = store;
        }
        const normalizedKey = normalizeI18nKey(key);
        const translation = GlobalTranslationStore.instance.getByKey(normalizedKey);
        if (translation)
            return translation;
        else
            return "";
    }
}
//# sourceMappingURL=global.js.map